import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API_BASE_URL from '../config/apiBaseUrl';
import fertLogo from '../assets/fert-logo-black.png';
import '../styles/Login.css';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const apiUrl = `${API_BASE_URL}/auth/login`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ username, password })
      });

      const text = await response.text();

      let data = null;
      if (text.trim() !== '') {
        try {
          data = JSON.parse(text);
        } catch (parseErr) {
          if (!response.ok) {
            throw new Error(`Erreur serveur (${response.status}). Le backend a renvoye une reponse invalide.`);
          }

          throw new Error(`Invalid response from server. Server returned: ${text.substring(0, 200)}`);
        }
      }

      if (!response.ok) {
        if (response.status >= 500) {
          throw new Error(`Erreur serveur (${response.status}). Verifiez le backend Symfony et les logs PHP.`);
        }

        throw new Error(data?.message || `Login failed: ${response.status}`);
      }

      if (data?.success) {
        login(data.user, data.token);
        navigate('/');
      } else {
        throw new Error('Reponse de connexion incomplete.');
      }
    } catch (err) {
      setError(err.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <section className="login-brand-panel">
          <div className="login-brand-mark">
            <img src={fertLogo} alt="Groupe Fert Recyclage" />
          </div>
          <span className="login-kicker">Groupe Fert Recyclage</span>
          <h1>Pilotage PRE</h1>
          <p>
            Une interface pour la veille marche, les vendeurs et les modules d'analyse.
          </p>
        </section>

        <section className="login-box">
          <h2>Connexion moderateur</h2>
          <p className="subtitle">Veille marche - application securisee</p>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="username">Identifiant</label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Entrez votre identifiant"
                autoComplete="username"
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Mot de passe</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Entrez votre mot de passe"
                autoComplete="current-password"
                disabled={loading}
                required
              />
            </div>

            <button type="submit" disabled={loading} className="submit-button">
              {loading ? 'Connexion en cours...' : 'Se connecter'}
            </button>
          </form>

          <div className="info-message">
            <p>Acces reserve aux moderateurs autorises.</p>
          </div>
        </section>
      </div>
    </div>
  );
}
